<script setup>
import { defineProps } from "vue";

const props = defineProps({
    show: { type: Boolean, required: true }, // controls open/close
    duration: { type: Number, default: 300 }, // ms
    easing: { type: String, default: "ease" }, // CSS timing function
    opacity: { type: Boolean, default: false }, // also fade in/out
});

function beforeEnter(el) {
    el.style.height = "0";
    if (props.opacity) el.style.opacity = "0";
    el.style.overflow = "hidden";
}

function enter(el) {
    el.style.transition = `height ${props.duration}ms ${props.easing}` + (props.opacity ? `, opacity ${props.duration}ms ${props.easing}` : "");
    // force reflow so the transition applies
    void el.offsetHeight;
    el.style.height = el.scrollHeight + "px";
    if (props.opacity) el.style.opacity = "1";
}

function afterEnter(el) {
    el.style.height = ""; // allow natural height after opening
    el.style.transition = "";
    el.style.overflow = "";
    if (props.opacity) el.style.opacity = "";
}

function beforeLeave(el) {
    el.style.height = el.scrollHeight + "px";
    el.style.overflow = "hidden";
    el.style.transition = `height ${props.duration}ms ${props.easing}` + (props.opacity ? `, opacity ${props.duration}ms ${props.easing}` : "");
    if (props.opacity) el.style.opacity = "1";
}

function leave(el) {
    // reflow
    void el.offsetHeight;
    el.style.height = "0";
    if (props.opacity) el.style.opacity = "0";
}

function afterLeave(el) {
    el.style.height = "";
    el.style.transition = "";
    el.style.overflow = "";
    if (props.opacity) el.style.opacity = "";
}
</script>

<template>
    <Transition
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
    >
        <!-- Use v-show so hooks run on show/hide without unmounting -->
        <div v-show="show">
            <slot />
        </div>
    </Transition>
</template>
